/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsquerySalesarticlesSummaryIdsGet$Plain$Params {
  ids?: Array<string>;
}

export function apiProductsquerySalesarticlesSummaryIdsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProductsquerySalesarticlesSummaryIdsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsquerySalesarticlesSummaryIdsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleSummary>>;
    })
  );
}

apiProductsquerySalesarticlesSummaryIdsGet$Plain.PATH = '/api/productsquery/salesarticles/summary/ids';
